var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpworkSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 14 14",
    role: "img",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 10.2805,7.579 c -0.551,0 -1.0675,-0.2335 -1.537,-0.6135 l 0.114,-0.538 0.004,-0.021 c 0.1035,-0.5715 0.4245,-1.53 1.4195,-1.53 0.746,0 1.3515,0.606 1.3515,1.3515 -5e-4,0.7445 -0.606,1.351 -1.352,1.351 z m 0,-4.07 C 9.011,3.509 8.0255,4.3335 7.6255,5.692 7.0155,4.775 6.5515,3.674 6.282,2.746 l -1.368,0 0,3.556 C 4.913,7.005 4.3435,7.575 3.6405,7.576 2.938,7.575 2.369,7.0045 2.368,6.302 l 0,-3.556 -1.368,0 0,3.556 C 1,7.759 2.185,8.9535 3.6405,8.9535 5.097,8.9535 6.282,7.759 6.282,6.302 l 0,-0.595 c 0.2645,0.5535 0.591,1.1145 0.987,1.6105 l -0.8365,3.9365 1.3985,0 0.6065,-2.855 C 8.969,8.7385 9.58,8.9535 10.2805,8.9535 11.7805,8.9535 13,7.7275 13,6.2285 13,4.7285 11.7805,3.509 10.2805,3.509 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpworkSvg);
export default __webpack_public_path__ + "static/media/Upwork-svg.01ce67823b290a1f10cf4ad52eab9295.svg";
export { ForwardRef as ReactComponent };